import axios from "axios";
import React from 'react';

export const UserLogin = async (data) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/user/login`, data,
      {
        headers: {
          "ngrok-skip-browser-warning": "true"
        }
      }
    )
    return response.data.token
  } catch (error) {
    console.error('Error sending email:', error)
    throw new Error('Failed to send email. Please try again later.')
  }
}

export const authenticateUser = async (token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/authen`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error authenticating user:', error.response ? error.response.data : error.message);
    throw new Error('Authentication failed');
  }
};

export const UserRegister = async (data, token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/user/create`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      },
    });
    return response.data.user;
  } catch (error) {
    // Check if the error response has a 401 status code
    if (error.response && error.response.status === 401) {
      throw new Error('บัญชีนี้มึอยู่แล้ว'); // Duplicate data error message
    } else {
      console.error('Error UserRegister:', error);
      throw new Error(error.message || 'An error occurred');
    }
  }
};

export const GetAllUser = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/user/all`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      },
    });
    //   console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw new Error("Failed to fetch users");
  }
};

export const getSummaryUserData = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/user/summary`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      },
    });
    //   console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching summary user data:", error);
    throw new Error("Failed to fetch summary user data");
  }
}

export const UpdateUserData = async (userData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/user/update/${userData.id}`,userData);
    //   console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error UpdateUserData  user data:", error);
    throw new Error("Failed to UpdateUserData user data");
  }
}

export const  GetUserById = async (id) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/user/user/${id}`);
    // console.log("GetUserById",response.data);
    return response.data;
  } catch (error) {
    console.error("Error GetUserById  user data:", error);
    throw new Error("Failed to GetUserById user data");
  }
};

export const SendMailForgotPassword = async (email) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/email/sendforgotpassword`, { email });
    return response.data;
  } catch (error) {
    console.error('Error sending email:', error)
    throw new Error('Failed to send email. Please try again later.')
  }
}

export const verifyOTP = async (email, otp) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/email/verifyotp`, { email, otp});
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error)
    throw new Error('Failed to verify OTP. Please try again later.')
  }
}

export const ResetPassword = async (data) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/user/resetpassword`, data);
    return response.data;
  } catch (error) {
    console.error('Error resetting password:', error)
    throw new Error('Failed to reset password. Please try again later.')
  }
};

export const SearchUserData = async (data,token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/user/user/search`, data , {
      headers: {
        'Authorization': `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true"
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error searching user data:', error)
    throw new Error('Failed to search user data. Please try again later.')
  }
};